import { createClient } from '@supabase/supabase-js'

// Your actual Supabase project details
const supabaseUrl = 'https://pawscdwbmlunuquaflxb.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBhd3NjZHdibWx1bnVxdWFmbHhiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc2MTAzOTcsImV4cCI6MjA3MzE4NjM5N30.JiCqjUEO5lyNbXzKUE3KM2BqwOELwFYgQ1f1uASfkfo'

// Validate configuration
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'X-Client-Info': 'empower-nutrition-courses'
    }
  }
})

// Test connection function
export const testSupabaseConnection = async () => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('count')
      .limit(1)

    if (error && error.code !== 'PGRST116') {
      // PGRST116 is "not found" which is OK
      console.error('Supabase connection error:', error)
      return false
    }

    console.log('✅ Supabase connection successful')
    return true
  } catch (error) {
    console.error('❌ Supabase connection failed:', error)
    return false
  }
}

export default supabase